"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickStoryEventPerPage = exports.clickStoryEvent = exports.sendStoryViewEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a story was viewed
 * Event name: "web:story:::view"
 */
var sendStoryViewEvent = function (eventInfo) {
    (0, _1.sendEvent)("story", null, null, "view", eventInfo);
};
exports.sendStoryViewEvent = sendStoryViewEvent;
/**
 * Sends an event that a specific page was viewed
 * Event name: "web:story:::click"
 */
var clickStoryEvent = function (eventInfo) {
    (0, _1.sendEvent)("story", null, null, "click", eventInfo);
};
exports.clickStoryEvent = clickStoryEvent;
/**
 * Sends an event when a user clicks on a story from the featured page
 * Event name: "web:featured:story::click"
 */
var clickStoryEventPerPage = function (page, eventInfo) {
    (0, _1.sendEvent)(page, "story", null, "click", eventInfo);
};
exports.clickStoryEventPerPage = clickStoryEventPerPage;
